
import { useState } from "react";
import { Box, Tab, Tabs, } from "@mui/material";
import { ROUTER_PATHS, a11yProps, sizeTab, texto, useCheckPermissions } from "@/shared";

import { SingleTableBoxScene } from "@/shared/components/ui";
import { CustomTabPanel } from "@/erp/sale/component";
import TableIngresoHistorialComponente from "../shared/componente/TableIngresoHistorialComponente";
import { PermissionsEnum } from "@/auth/interfaces";

export default function IngresoInventarioHistorialPage() {

  useCheckPermissions(PermissionsEnum.api_view_ingresoinventario);
  
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      //title={"Ingresos Historial"}
      title={"Reporte Ingresos Inventario"}
      //backPageUrl={ROUTER_PATHS.inventario.ingresoInventario}
      urlRedirect={`${ROUTER_PATHS.inventario.ingresoInventario}`}
      enableBackBtn={true}
    >

      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={texto.historial} {...a11yProps(0)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <TableIngresoHistorialComponente />
      </CustomTabPanel>

    </SingleTableBoxScene >
  );


}